import { createInstance } from '@optimizely/react-sdk';
import { Config } from '~/adapters/config/config';
import { createUseFeatureFlag } from '~/contexts/OptimizelyContext';

export const FullstackOptimizely = createInstance({
    sdkKey: Config.ACCOUNTS_OPTIMIZELY_SDK_FULLSTACK,
    datafileOptions: {
        updateInterval: 300000,
        autoUpdate: true,
        urlTemplate: `${Config.ACCOUNTS_OPTIMIZELY_PROXY_URL}/datafiles/%s.json`,
    },
});

export type OnOffVariant = 'on' | 'off';

// Feature Flags as [key: variant type], all of them can be found in optimizely, but not vice versa (archived flags aren't here anymore)
// https://app.optimizely.com/v2/projects/21834413098/flags/list
export type FullstackFeatureFlags = {
    auth0_rollout: OnOffVariant;
};

export const useFeatureFlag = createUseFeatureFlag<FullstackFeatureFlags>();

type OnOffVariantFeatureFlagKeys = {
    [TKey in keyof FullstackFeatureFlags]: FullstackFeatureFlags[TKey] extends OnOffVariant ? TKey : never;
}[keyof FullstackFeatureFlags];

// helper hook for flags which have boolean meaning (on / off)
export const useFeatureFlagEnabled = (flag: OnOffVariantFeatureFlagKeys): boolean => {
    const flagKey = useFeatureFlag(flag);
    return flagKey === 'on';
};
